import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <>
      <div className="floating-header">
        <div className="logo-container">
          <h1 className="shiny-text">Kho Gạo Vinh Phước</h1>
          <p className="subtitle glowing-text">Chất Lượng Tạo Nên Thương Hiệu</p>
        </div>
      </div>
      <nav className="nav-menu">
        <div className="container">
          <ul className="nav-links">
            <li><Link to="/">Trang Chủ</Link></li>
            <li><Link to="/products">Sản Phẩm</Link></li>
            <li><Link to="/about">Về Chúng Tôi</Link></li>
            <li><Link to="/contact">Liên Hệ</Link></li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar; 